<template>
  <div>
    <v-divider></v-divider>
    <v-footer
      color="#000"
      :min-height="$vuetify.breakpoint.name == 'xs' ? 'auto' : '50px'"
    >
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-layout wrap justify-center>
            <v-flex align-self-center xs12 px-md-4 px-lg-6>
              <v-layout
                wrap
                justify-center
                :text-left="$vuetify.breakpoint.name == 'xs' ? true : false"
              >
               
              <v-flex xs12 sm10 md8 lg6 align-self-center>
  <v-row justify="space-between" align="center" class="flex-column flex-sm-row text-center text-sm-left">
    
    <!-- Terms and Conditions (Left on larger screens, top on xs) -->
    <v-col cols="12" sm="auto" class="mb-2 mb-sm-0">
      <span
        style="
          color: #d1d1d1;
          font-family: Lato-Regular;
          font-size: 14px;
          cursor: pointer;
        "
        @click="$router.push('/terms-and-conditions')"
      >
        Terms and Conditions
      </span>
    </v-col>

    <!-- Copyright (Center) -->
    <v-col cols="12" sm="auto" class="mb-2 mb-sm-0">
      <span
        style="
          color: #d1d1d1;
          font-family: Lato-Regular;
          font-size: 14px;
        "
      >
        Copyrights © 2025 Teamite.inc
      </span>
    </v-col>

    <!-- Privacy Policy (Right on larger screens, bottom on xs) -->
    <v-col cols="12" sm="auto">
      <span
        style="
          color: #d1d1d1;
          font-family: Lato-Regular;
          font-size: 14px;
          cursor: pointer;
        "
        @click="$router.push('/refund-policy')"
      >
        Refund Policy
      </span>
    </v-col>

  </v-row>
</v-flex>


            
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>



    
  </div>
</template>
  <script>

export default {
 
  data() {
    return {
   
    
    };
  },

 
  methods: {
 
  },
};
</script>



